/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ContainerFindingsBaseFilters {
    getFixupPrototypeFunction() { return ContainerFindingsBaseFilters.fixupPrototype; }

    static newInstance(model: Partial<ContainerFindingsBaseFilters>): ContainerFindingsBaseFilters {
        let obj = Object.assign(new ContainerFindingsBaseFilters(), model);
        ContainerFindingsBaseFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ContainerFindingsBaseFilters>): ContainerFindingsBaseFilters {
        if (!model) return null;
        return ContainerFindingsBaseFilters.newInstance(<ContainerFindingsBaseFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ContainerFindingsBaseFilters) {
        if (!obj) return;

        models.ContainerFindingsBaseFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ContainerFindingsBaseFilters): boolean {
        Object.setPrototypeOf(obj, ContainerFindingsBaseFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Tenant ID to which the findings are associated
     */
    tenant_id: string;

    /**
     * Query based on SBOM version ID, Category, Execution Phase, Severity and Status
     */
    filters: models.QueryOperator;

}
